/**
 * WssMap Component
 * Google Maps wrapper for displaying WSS location
 */

import React from "react";
import { GoogleMap } from "@shared/components";
import Message from "@features/shared/components/Message";
import { MdLocationOff } from "react-icons/md";
import styles from "@components/MarketWorking/MyTeam/MyDealer.module.css";

const WssMap = ({ latitude, longitude, locationError, currentLatitude, currentLongitude }) => {
  if (locationError) {
    return (
      <div className={styles.myDealer__googleMap_Box}>
        <Message
          message="Location access denied. Please update your browser settings to grant location permission."
          className="DealerLocatorForm__mapAccess"
          icon={
            <MdLocationOff
              style={{ color: "#808080", height: "2em", width: "2em" }}
            />
          }
        />
      </div>
    );
  }

  // Use WSS coordinates if available, otherwise use current location
  const mapLat = latitude != null && !isNaN(latitude) ? parseFloat(latitude) : currentLatitude;
  const mapLng = longitude != null && !isNaN(longitude) ? parseFloat(longitude) : currentLongitude;

  return (
    <div className={styles.myDealer__googleMap_Box}>
      <GoogleMap lat={mapLat} long={mapLng} zoom={12} />
    </div>
  );
};

export default WssMap;
